import { HttpRequest, HttpRequestLog } from './HttpRequest'

export const SearchPlanningTransfer = async (request: ISearchPlanningTransferRequest) => {
    let data = JSON.stringify(request);
    try {
        const response = await HttpRequest().post(`/planning/cr/transfer/search`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw new Error('error api /planning/transfer')
    }
}

export const SavePlanningTransfer = async (objectDeedProspect: any) => {
    let data = JSON.stringify(objectDeedProspect);
    try {
        const response = await HttpRequest().post(`/planning/cr/transfer/save`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'UPDATED') {
            return {
                status: "UPDATED",
                msg: ""
            }
        } else {
            return {
                status: "ERROR",
                msg: response.data.error
            }
        }
    } catch (error: any) {
        if (error.response.status === 400) return {
            status: "ERROR",
            msg: error.response.data
        } 
        throw new Error('error api /planning/cr/transfer/save')
    }
}

export const addLog =  (objectSearch: any) => {
    let data = JSON.stringify(objectSearch);
    try {
        const response = HttpRequestLog().post(`/jsondata/addlog`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('Error add Log api' + error.response.data.message)
    }
}


export interface ISearchPlanningTransferRequest {
    projectId: string
    unitSelectType: string
    unitSelected: string[]
    unitFrom: string
    unitTo: string
    // * วันที่จอง
    bookingDateFrom: string 
    bookingDateTo: string
    // * วันที่ทำสัญญา
    contractDateFrom: string
    contractDateTo: string
    // * วันที่โอนตามสัญญา
    contractTransferDateFrom: string
    contractTransferDateTo: string
    // * สรุปวันโอน(Plan+Actual)
    finalTransferDateFrom: string
    finalTransferDateTo: string
    // * CR Plan วันโอน
    crPlanDateFrom: string
    crPlanDateTo: string
    // * วันที่นัดโอน
    transferPlanDateFrom: string
    transferPlanDateTo: string
    // * สถานะการโอน
    transferStatusId: string
    // * สถานะการรับมอบ
    recieceStatus: string
    // * CR ผู้รับผิดชอบการโอน
    crId: string
    // * Sales
    salesId: string
    // * กลุ่มลูกค้า
    nationalityType: string
    // * Payment Method
    paymentMethodsId: string
    // * สถานะการขาย
    statusSold: string[]
    addressNoText: string
}

export interface ISearchPlanningTransferResponse {
    unitId: number
    unitCode: string
    bookingId: number
    sapContractNo: string
    signId: number
    activeSign: boolean
    transferId: number
    prospectId: number
    landArea: number
    usageArea: number
    landSize: number
    usageSize: number
    addressNo: string
    areaValue: number
    customerName: string
    contractUnitPrice: number
    netPrice: number
    bookActivityDate: string
    signActivityDate: string
    signActivityId: number
    contractTransferDate: string
    letterRequestExtendReduceTransferDate: string
    contactStatusId: number
    receivePromotionId: number
    joinEventId: number
    purposeOfBuyId: number
    customerDepositStock: boolean
    sendRoomStatus: string
    inspection1SendRoomDate: string
    inspection1Id: number
    inspection1PlanPJDate: string
    inspection1AppointmentStatusId: number
    inspection1TypeId: number
    inspection1TypeText: string
    inspection1PlanCRDate: string
    inspection1PlanCRTime: string
    inspection1PlanCRDateEdit: any
    inspection2SendRoomDate: string
    inspection2Id: number
    inspection2PlanPJDate: string
    inspection2AppointmentStatusId: number
    inspection2TypeId: number
    inspection2TypeText: string
    inspection2PlanCRDate: string
    inspection2PlanCRTime: string
    inspection2PlanCRDateEdit: any
    inspection3SendRoomDate: string
    inspection3Id: number
    inspection3PlanPJDate: string
    inspection3AppointmentStatusId: number
    inspection3TypeId: number
    inspection3TypeText: string
    inspection3PlanCRDate: string
    inspection3PlanCRTime: string
    inspection3PlanCRDateEdit: any
    inspection4SendRoomDate: string
    inspection4Id: number
    inspection4PlanPJDate: string
    inspection4AppointmentStatusId: number
    inspection4TypeId: number
    inspection4TypeText: string
    inspection4PlanCRDate: string
    inspection4PlanCRTime: string
    inspection4PlanCRDateEdit: any
    vipStatus: string
    saleStatus: string
    model: string
    mobilePhone: string
    country: string
    country2?: string
    country3?: string
    country4?: string
    email: string
    paymentLast: string
    inspectionNumLatest: number
    inspectionSendRoomDateLatest: string
    inspectionAppointmentStatusLatest: number
    inspectionPlanCRDateLatest: string
    inspectionPlanCRTimeLatest: string
    inspectionTypeTextLatest: string
    crPlan: string
    transferPlanDate: string
    transferOutDateHistory: string
    transferDateReal: string
    flagActiveTransfer: boolean
    expectTranMonth: string
    transferStatusId: number
    transferTypeId: number
    creditAppv: number
    bankId: number
    bankName: string
    useBankReason: string
    usedBankCount: number
    transferCRRemark: string
    deedName1: string
    deedName2: string
    deedName3: string
    deedName4: string
    operationId: number
    operationTime: string
    mortgageValue: string
    mortgageCompValue: string
    lettTransRemark: string
    transferPlanDateSp: string
    flagTransferLetter: boolean
    transferLetterDate: string
    flagHaveAddress: string
    flagTransferOutLetter: boolean
    transferOutLetterDate: string
    flagTransferChangeLetter: boolean
    transferChangeLetterDate: string
    flagTransferAdjustLetter: boolean
    flagTransferAdjustLetterBefore: boolean
    transferAdjustLetterDate: string
    flagTransferCancelLetter: boolean
    transferCancelLetterDate: string
    flagTransferOutCancelLetter: boolean
    transferOutCancelLetterDate: string
    inspectionLetter1: string
    inspectionLetter2: string
    receiveHCLetter: string
    transferPlanDateLetter1: string
    transferOut1: string
    transferPlanDateLetter2: string
    transferOut2: string
    payStatus100pc: number
    payStatus100pcCusOverPay: number
    reasonStatus100pc: string
    unitStatus: string
    finalPlanDate: string
    finalActualDate: string
    salesName: string
    crId: number
    paymentMethod: string
    summaryRoomStatus: string
    agentName: string
    signProspectId1?: string
    signProspectId2?: string
    signProspectId3?: string
    signProspectId4?: string
    fullNameTH1?: string
    fullNameEN1?: string
    fullNameTH2?: string
    fullNameEN2?: string
    fullNameTH3?: string
    fullNameEN3?: string
    fullNameTH4?: string
    fullNameEN4?: string
    nationalityId: string
    flagInspectorContractor: boolean
    inspectorName: string
    transferUpdatedDate: Date
    crComment: string
    pjComment: string
    bankCreditStatus: string
}
